import React from 'react';

import { ColorDSD, ColorHex } from '../';
import { Box } from '@material-ui/core';

export interface IHr {
    color?: ColorDSD;
    backgroundColor?: ColorHex;
    height?: string;
    margin?: string;
}

export const Hr: React.FC<IHr> = ({
    color,
    backgroundColor,
    height,
    margin
}) => (
    <Box margin={margin} minWidth="100%">
        <hr
            className={color}
            style={{
                height: height,
                backgroundColor: backgroundColor
            }}
        />
    </Box>
);
